document.getElementById('calculate-shipping').addEventListener('click', function() {
    const zipCode = document.getElementById('zip-code').value;
    const shippingResults = document.getElementById('shipping-results');
    const variantId = document.getElementById('shipping-calculator').dataset.variantId;
  
    shippingResults.innerHTML = '<p>calculando frete...</p>';
  
    if (!zipCode) {
      alert('por favor, insira seu CEP');
      shippingResults.innerHTML = '';
      return;
    }
    
    if (typeof gtag === 'function') {
        gtag('event', 'shipping_calculated', {
            'event_category': 'Session',
            'event_label': 'Shipping Calculated'
        });
    } 
    if (typeof fbq === 'function') {
        fbq('trackCustom', 'ShippingCalculated', {
            'event_category': 'Session',
            'event_label': 'Shipping Calculated'
        });
    }

    // Track whether we added an item for calculation purposes
    let addedItemForCalculation = false;
    let addedItemLineIndex = null;
    console.log("Variant ID:", variantId);
    // First check if we have a product in cart already
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Check if this variant is already in cart
        const variantInCart = cart.items.some(item => item.id === parseInt(variantId));
        console.log(cart);
        
        if (cart.item_count == 0) {
          console.log("Cart is empty. Adding item temporarily for shipping rate calculation.");
          // If cart is empty or doesn't contain this variant, add it temporarily
          addedItemForCalculation = true;
          
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          })
          .then(response => response.json())
          .then(addedItem => {
            // Get updated cart to find the line index of our added item
            return fetch('/cart.js')
              .then(response => response.json())
              .then(updatedCart => {
                // Find the line index of our added variant (1-based index for Shopify cart)
                for (let i = 0; i < updatedCart.items.length; i++) {
                  if (updatedCart.items[i].id === parseInt(variantId)) {
                    addedItemLineIndex = i + 1; // Shopify uses 1-based index
                    break;
                  }
                }
                // Continue with shipping rate calculation
                return calculateShippingRates(zipCode, shippingResults);
              });
          })
          .then(() => {
            // Only remove the item we added if we actually added one
            if (addedItemForCalculation && addedItemLineIndex) {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                  line: addedItemLineIndex,
                  quantity: 0 
                })
              });
            }
          });
        } else {
          // Cart already has the variant, just calculate shipping
          console.log("Cart already has the variant. Calculating shipping rates.");
          return calculateShippingRates(zipCode, shippingResults);
        }
      })
      .catch(error => {
        console.error("Error:", error);
        shippingResults.innerHTML = '<p>Erro ao calcular o frete: ' + error.message + '</p>';
      });
});

function calculateShippingRates(zipCode, shippingResults) {
  // Format zipcode to ensure it's properly formatted (remove any non-numeric chars)
  const formattedZipCode = zipCode.replace(/\D/g, '');
  
  // Shopify shipping calculator needs a properly formatted URL with all required parameters
  const url = `/cart/shipping_rates.json?shipping_address%5Bcountry%5D=Brazil&shipping_address%5Bprovince%5D=Rio+Grande+Do+Sul&shipping_address%5Bzip%5D=${formattedZipCode}`
  
  return fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log("Shipping rate response:", data); // Log the full response for debugging
      shippingResults.innerHTML = '';

      if (!data.shipping_rates || data.shipping_rates.length === 0) {
        shippingResults.innerHTML = '<p>Não há opções de frete disponíveis para este CEP.</p>';    
        return;
      }

      // Display shipping rates
      const ratesList = document.createElement('ul');
      ratesList.className = 'shipping-rates-list';
      
      data.shipping_rates.forEach(rate => {
        const listItem = document.createElement('li');
        
        // Format price in BRL
        const price = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).format(rate.price);

        // Create the name and price part
        const namePrice = document.createElement('span');
        namePrice.innerHTML = `${rate.name}: <strong>${price}</strong>`;

        listItem.appendChild(namePrice);

        // Create the delivery days part
        if (rate.delivery_days && rate.delivery_days.length > 0) {
          const deliveryInfo = document.createElement('div');
          deliveryInfo.className = 'delivery-info';
          
          if (rate.delivery_days.length === 1) {
            deliveryInfo.textContent = `${rate.delivery_days[0]} dia útil`;
          } else if (rate.delivery_days.length >= 2) {
            deliveryInfo.textContent = `${rate.delivery_days[0]}-${rate.delivery_days[rate.delivery_days.length-1]} dias úteis`;
          }
          
          listItem.appendChild(deliveryInfo);
        }

        ratesList.appendChild(listItem);
      });
      
      shippingResults.appendChild(ratesList);
    });
}